import { map } from 'ramda';
import { v4 as uuidv4 } from 'uuid';
import { Integration } from '../../../../common/enums/Integration';
import { Routes } from '../../../../common/enums/Routes';
import { setObject } from '../../../../common/helpers/storageHelper';
import { INameData } from '../../../../common/models/common/INameData';
import { env } from '../../../../env';

const { lever: { authURL, clientId, scopes, baseURL } } = env;

export const getOAuthState = (): string => {
  const state = uuidv4();
  setObject('OAuthState', { key: Integration.Lever, value: state });

  return state;
};

export const openLeverAuthWindow = () => {
  const state = getOAuthState();
  const authURI = `${authURL}?client_id=${clientId}&redirect_uri=${window.location.protocol}//${
    window.location.host}${Routes.IntegrationsCallback}&state=${state}&response_type=code&scope=${
    scopes}&prompt=consent&audience=${baseURL}`;

  window.open(encodeURI(authURI), '_blank', 'location=yes,height=600,width=550');
};

export const fromINameDataToICustomSelectData = (data: INameData[]): Array<{ value: string; label: string }> => map(
  ({ id, name }) => ({ value: id, label: name }),
  data
);
